import './style.css';

import { Checkbox } from '@material-ui/core';
import React from 'react';
import QuickPickContainer from '../container';
import { getNestedLookUpObjectKeysByPosition, onSelectHandler } from '../quick-pick-helper.ts';

class QuickPickMulti extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = { transition: 'slide-right' };
  }

  UNSAFE_componentWillReceiveProps(n) {
    let { selected } = this.props;
    if (n.selected === selected) {
      return;
    }
    let transition = n.selected.length > selected.length ? 'slide-left' : 'slide-right';
    this.setState({ transition: transition });
  }

  render() {
    let { menu, selected, other, onChange, multiSelect, value } = this.props;
    let quickPicks = null;

    menu = !!menu.toJS ? menu.toJS() : menu;
    menu = Object.prototype.toString.call(menu) !== '[object Array]' ? menu[selected] : menu;

    let keys = getNestedLookUpObjectKeysByPosition(menu, selected);
    const selectedValues = Object.keys(value || {});

    quickPicks = keys.map((key, i) => {
      let hasChildSelected = selectedValues.some((x) => x.indexOf(key) === 0 && x !== key);

      let alt = null;
      let text = menu[key];

      if (typeof menu[key] === 'object') {
        alt = menu[key].alt || '';
        text = menu[key].description || '';
      }

      let page = this.props.menu[key];
      let isMenu = typeof page === 'object' && Object.keys(page).length > 1;

      return (
        <div
          key={i}
          className={'menu-item'}
          tabIndex={i}
          onClick={this.onSelect.bind(this, key, text)}
        >
          <Checkbox
            className="multi-check-box"
            checked={hasChildSelected || (selectedValues || []).indexOf(key) >= 0}
          />
          <span className="text">{text}</span>
          <span className="text">{alt}</span>
          <span className={isMenu ? 'fa fa-chevron-right' : ''} />
        </div>
      );
    });

    //Other option should only be displayed on the main list and not for sub list
    if (other && selected == 'main')
      quickPicks.push(
        <div
          key={'other'}
          className={'menu-item'}
          tabIndex={keys.length}
          onClick={this.onSelect.bind(this, 'other', 'other')}
        >
          <Checkbox className="multi-check-box" checked={value.hasOwnProperty('other')} />
          <span className="text">Other</span>
        </div>
      );

    return (
      <QuickPickContainer {...this.props} {...this.state} onBack={this.onBack.bind(this)}>
        <div key={selected} className="content">
          {quickPicks}
        </div>
      </QuickPickContainer>
    );
  }

  onSelect(key, text, e, checked) {
    onSelectHandler(key, text, e, this.props);
  }

  onBack() {
    let { selected } = this.props;
    this.props.onNavigate(selected.substring(0, selected.lastIndexOf('.')));
  }
}

QuickPickMulti.defaultProps = {
  selected: 'main',
  onChange: () => {},
  onNavigate: () => {}
};

export default QuickPickMulti;
